import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DateFilter } from "../../public/interfaces/DateFilter";
import { Tag } from "../../public/interfaces/Tag";
import { TipFilters } from "../../public/interfaces/TipFilters";
import { TipFiltersState } from "../../public/interfaces/TipFiltersState";
import { Author } from "../../public/interfaces/Author";
import { ContentLengthOptions } from "../../public/enums/ContentLengthOptions";

const initialTipFilters: TipFilters = {
  hasWords: null,
  tags: [],
  authors: [],
  date: null,
  contentLength: ContentLengthOptions.LONG,
};

const initialState: TipFiltersState = {
  tipFilters: initialTipFilters,
};

export const tipFiltersSlice = createSlice({
  name: "tipFilters",
  initialState,
  reducers: {
    setTipsHasWords: (state, action: PayloadAction<string | null>) => {
      state.tipFilters.hasWords = action.payload;
    },
    setTipsDate: (state, action: PayloadAction<DateFilter | null>) => {
      state.tipFilters.date = action.payload;
    },
    setTipsTags: (state, action: PayloadAction<Tag[]>) => {
      state.tipFilters.tags = action.payload;
    },
    setTipsAuthors: (state, action: PayloadAction<Author[]>) => {
      state.tipFilters.authors = action.payload;
    },
    setTipContentLength: (
      state,
      action: PayloadAction<ContentLengthOptions>
    ) => {
      state.tipFilters.contentLength = action.payload;
    },
    setAllTipFilters: (
      state,
      action: PayloadAction<{
        hasWords: string | null;
        date: DateFilter | null;
        tags: Tag[];
        authors: Author[];
        contentLength: ContentLengthOptions;
      }>
    ) => {
      state.tipFilters = action.payload;
    },
    resetAllTipFilters: (state) => {
      state.tipFilters = initialTipFilters;
    },
  },
});

export const {
  setTipsHasWords,
  setTipsTags,
  setTipsAuthors,
  setTipsDate,
  setTipContentLength,
  setAllTipFilters,
  resetAllTipFilters,
} = tipFiltersSlice.actions;
export default tipFiltersSlice;
